import { gql } from '@apollo/client';

export const CREDIT_DECISION_PARSED_DATA_FRAGMENT = gql`
  fragment CreditDecisionParsedDataFields on CreditDecisionParsedData {
    parsedDecisionId
    reviewStatus
    confidenceScore
    requiresManualReview
    reviewNotes
    createdDateTime
    modifiedDateTime
    parsedData {
      # Decision
      decisionType
      decisionDate
      expirationDate
      declineReasons

      # Parties
      applicantName
      businessName
      coBorrowerName
      underwriterName
      dealerName
      dealerContact
      dealerEmail
      guarantorRequired
      guarantorName

      # Core financials
      approvalAmount
      invoiceAmount
      salesPrice

      # Term & rates
      termLengthMonths
      interestRate
      dealerBuyRate
      customerRate
      apr
      monthlyPayment

      # Deal structure
      typeOfFinancing
      cashDown
      netTradeIn
      rentalCredit
      taxesAndFees
      residualAmount
      balloonPayment
      irregularPayments

      # Upfront / payment structure
      downPaymentToVendor
      minimumRequiredDownPayment
      totalDueAtSigning
      advancePaymentsCount
      daysToFirstPayment
      firstPaymentDueDate
      paymentCalculationType

      # Program
      programName
      programDetails
      partnerStatus
      partnerBenefitsEligible

      # Dealer
      dealerCommission

      # Arrays
      conditions
      stipulations
      comments
      lenderFees {
        feeName
        amount
        canBeFinanced
        description
      }
      termOptions {
        termLengthMonths
        interestRate
        monthlyPayment
        apr
        isRecommended
        description
      }
      paymentTiers {
        months
        monthlyPayment
        description
      }
    }
  }
`;
